import { FiUserCheck } from "react-icons/fi";
import { SlLocationPin } from "react-icons/sl";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { BsBriefcase } from "react-icons/bs";
import { LiaMedalSolid } from "react-icons/lia";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { MdUpdate } from "react-icons/md";
import { useEffect, useState } from "react";
import moment from "moment";
import {
  jobDetails,
  resumelistForAgent,
  uploadResume,
  uploadResumeList,
} from "../service/apis/auth.api";
import { AppRoute } from "../router/routerConstants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useCustomNavigate } from "../hooks/useCustomNavigate";
import { showError, showSuccess } from "../utils/Common";
import Loader from "./Loader/loader";
import { addResumeToList, clearAllResumes, ResumeDetails } from "../store/resume.store";
import ResumeListModal from "./ResumeList/resume-popup";
import DOMPurify from "dompurify";

const JobDetails = ({ jobId, applyStatus }: any) => {
  const [jobData, setJobData] = useState<any>(null);
  const [NavigateTo] = useCustomNavigate();
  const { user } = useSelector((state: RootState) => state.authSlice);
  const { resumeDetails, resumeList } = useSelector(
    (state: RootState) => state.resumeSlice
  );
  const [showModal, setShowModal] = useState(false);
  // const [selectedResumes, setSelectedResumes] = useState<ResumeDetails[]>([]);

  const [isApplied, setIsApplied] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  useEffect(() => {
    fetchJobDetails();
    // fetchAppliedDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);

  const fetchJobDetails = async () => {
    try {
      setIsLoading(true);
      const response = await jobDetails(jobId);
      setJobData(response?.job);
    } catch (err: any) {
      showError(err?.message);
    } finally {
      setIsLoading(false);
    }
  };

  // const fetchAppliedDetails = async () => {
  //   try {
  //     // setLoading(true);
  //     const response = await appliedDetails(jobId);
  //     console.log("response", response);

  //     setIsApplied(response?.detailApplication?.[0]?.status);
  //   } catch (err: any) {
  //     showError(err?.message);
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  const handleClick = () => {
    const params = {
      jobId: jobId,
      explevel: jobData?.experience,
    };
    if (!user) {
      NavigateTo(AppRoute.LOGIN, false, params);
    } else {
      if (user && user?.role === "jobseeker") {
        if (resumeDetails && resumeDetails?.resumeLink) {
          let payload = {
            jid: jobId,
            name: resumeDetails?.name,
            email: resumeDetails?.email,
            contact: resumeDetails?.contact,
            explevel: resumeDetails?.explevel,
            resume: resumeDetails?.resumeLink,
          };          
          upload(payload);
        } else {
          NavigateTo(AppRoute.JOBSEEKER_MY_RESUME, false, params);
        }
      } else if (user && user?.role === "localagents") {
        if (resumeList && resumeList?.length > 0) {
          handleShowModal();
        } else {
          NavigateTo(AppRoute.AGENT_MY_RESUME, false, params);
        }
      }
    }
  };

  const handleSelectUsers = async (resumes: ResumeDetails[]) => {
    // setSelectedResumes(resumes);

    // let payload = {
    //   jid: jobId,
    //   name: resumeDetails?.name,
    //   email: resumeDetails?.email,
    //   contact: resumeDetails?.contact,
    //   explevel: resumeDetails?.explevel,
    //   resume: resumeDetails?.resumeLink,
    // };
    let payload = {
      jid: jobId,
      candidates:
        resumes &&
        resumes?.map((resume) => ({
          name: resume.name,
          email: resume.email,
          contact: resume.contact,
          explevel: resume.explevel,
          resume: resume.resumeLink,
        })),
    };
    await uploadResumeByLocalAgent(payload);
    getResumeListForAgent(jobId);
    // Here you can handle further processing like uploading, etc.
  };

  const upload = async (payload?: any) => {
    try {
      const response = await uploadResume(payload);
      showSuccess(response?.message);
      if (user && user?.role === "jobseeker") {
        setIsApplied(response?.application?.status);
      }
    } catch (err: any) {
      showError(err?.message);
    } finally {
      // setLoading(false);
    }
  };

  const uploadResumeByLocalAgent = async (payload?: any) => {
    try {
      const response = await uploadResumeList(payload);
      showSuccess(response?.message);
      if (user && user?.role === "jobseeker") {
        setIsApplied(response?.application?.status);
      }
    } catch (err: any) {
      showError(err?.message);
    } finally {
      // setLoading(false);
    }
  };

  const decodeHtml = (html = "") => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };
  /*const sanitizeData = (htmldata = "") => {
    const sanitizedDescription = decodeHtml(htmldata);
    return (
      <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
    );
  };*/

  const sanitizeData = (htmldata = "") => {
    const decodedData = decodeHtml(htmldata);

    const sanitizedDescription = DOMPurify.sanitize(decodedData, {
      ALLOWED_TAGS: [
        "p",
        "strong",
        "em",
        "u",
        "ol",
        "ul",
        "li",
        "a",
        "blockquote",
        "code",
        "h1",
        "h2",
        "h3",
      ],
      ALLOWED_ATTR: ["href", "target", "rel"],
    });

    return (
      <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
    );
  };

    const dispatch = useDispatch();
    const getResumeListForAgent = async (jobId: string = "") => {
      let payload = {
        jid: jobId,
      };
      try {
        // setLoading(true);
        const response = await resumelistForAgent(payload);
        // console.log(response, "response resume list");
        const updatedDetails = {
          resumeDetails:
            response?.data?.filteredResumes &&
            response?.data?.filteredResumes?.map((resumeDetail: any) => ({
              name: resumeDetail?.resume?.resumeData?.name,
              bio: resumeDetail?.resume?.resumeData?.bio,
              email: resumeDetail?.resume?.resumeData?.email,
              explevel: resumeDetail?.resume?.resumeData?.explevel,
              contact: resumeDetail?.resume?.resumeData?.contact,
              experiences: resumeDetail?.resume?.resumeData?.experiences,
              skills: resumeDetail?.resume?.resumeData?.skills,
              achievements: resumeDetail?.resume?.resumeData?.achievements,
              educations: resumeDetail?.resume?.resumeData?.educations,
              resumeLink: resumeDetail?.resume?.resumeLink,
              _id: resumeDetail?._id,
            })),
        };

        dispatch(clearAllResumes());
        updatedDetails.resumeDetails.forEach((resumeDetail: ResumeDetails) => {
          dispatch(addResumeToList(resumeDetail));
        });
      } catch (err: any) {
        showError(err?.message);
      } finally {
        // setLoading(false);
      }
    };
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className={`profileJoblisting-holder jobsDetails `+ (user?.role?user.role:'')}>
          <div className="row">
            <div className="col-lg-12">
              <div className="title">
                <h2>{jobData?.title}</h2>
              </div>
            </div>
            <div className="col-lg-4">
              <h3>Job Information</h3>
              <div className="jobInformation comnbrdrGap mb-5">
                <ul>
                  <li>
                    <span>
                      <FiUserCheck />
                    </span>
                    <h4>
                      Employee Type:{" "}
                      <strong>{jobData?.type?.typeName || "N/A"}</strong>
                    </h4>
                  </li>
                  <li>
                    <span>
                      <SlLocationPin />
                    </span>
                    <h4>
                      Location: <strong>{jobData?.location || "N/A"}</strong>
                    </h4>
                  </li>
                  <li>
                    <span>
                      <HiOutlineBuildingOffice2 />
                    </span>
                    <h4>
                      Company Name:{" "}
                      <strong>
                        {jobData?.userID?.externalInfo?.name || "N/A"}
                      </strong>
                    </h4>
                  </li>
                  <li>
                    <span>
                      <BsBriefcase />
                    </span>
                    <h4>
                      Job Type:{" "}
                      <strong>
                        {jobData?.category?.categoryName || "N/A"}
                      </strong>
                    </h4>
                  </li>
                  <li>
                    <span>
                      <LiaMedalSolid />
                    </span>
                    <h4>
                      Experience:{" "}
                      <strong>{jobData?.experience || "N/A"}</strong>
                    </h4>
                  </li>
                  <li>
                    <span>
                      <AiOutlineDollarCircle />
                    </span>
                    <h4>
                      Salary:{" "}
                      <strong>
                        {jobData?.salaryMin || "N/A"} -{" "}
                        {jobData?.salaryMax || "N/A"}
                      </strong>
                    </h4>
                  </li>
                  <li>
                    <span>
                      <MdUpdate />
                    </span>
                    <h4>
                      Date posted:{" "}
                      <strong>
                        {jobData?.deadlineDate
                          ? moment(jobData?.deadlineDate).format("Do MMM, YYYY")
                          : "N/A"}
                      </strong>
                    </h4>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="row">
                <div className="col-lg-12">
                  <div className="jobDetails-info pb-5 mb-5">
                    <div className="singlestep mb-5">
                      <h3>Job Description:</h3>
                      {sanitizeData(jobData?.description)}
                    </div>
                    <div className="singlestep mb-5">
                      <h3>Required Experience, Skills and Qualifications:</h3>
                      {/* <p>
                      It sometimes makes sense to select texts containing the
                      various letters and symbols specific to the output
                      language.
                    </p> */}
                      {sanitizeData(jobData?.des_skills)}
                    </div>
                    <div className="singlestep mb-5">
                      <h3>Responsibilities and Duties:</h3>
                      {/* <p>
                      It sometimes makes sense to select texts containing the
                      various letters and symbols specific to the output
                      language.
                    </p> */}

                      {sanitizeData(jobData?.responsibilities)}

                      {applyStatus || isApplied === "applied" ? (
                        <span
                          className="btn applied"
                          style={{ cursor: "auto" }}
                        >
                          Applied
                        </span>
                      ) : (
                        /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                        <a className="btn applynow" onClick={handleClick}>
                          Apply Now
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Bulk Upload */}
      {showModal && (
        <ResumeListModal
          showWork={showModal}
          handleCloseWK={handleCloseModal}
          resumeList={resumeList}
          onSelectUsers={handleSelectUsers}
        />
      )}
    </>
  );
};
export default JobDetails;
